"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LoginForm = void 0;

var _react = _interopRequireDefault(require("react"));

var _antd = require("antd");

var PropTypes = _interopRequireWildcard(require("prop-types"));

var _Loader = _interopRequireDefault(require("../../components/Loader"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var FormItem = _antd.Form.Item;

var LoginForm =
/*#__PURE__*/
function (_React$Component) {
  _inherits(LoginForm, _React$Component);

  function LoginForm() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, LoginForm);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(LoginForm)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "handleSubmit", function (e) {
      var auth = _this.props.auth;
      e.preventDefault();

      _this.props.form.validateFields(function (err, values) {
        if (!err) {
          auth(values.username, values.password);
        }
      });
    });

    return _this;
  }

  _createClass(LoginForm, [{
    key: "hasErrors",
    value: function hasErrors(fieldsError) {
      return Object.keys(fieldsError).some(function (field) {
        return fieldsError[field];
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          error = _this$props.error,
          translate = _this$props.translate,
          isLoading = _this$props.isLoading;
      var _this$props$form = this.props.form,
          getFieldDecorator = _this$props$form.getFieldDecorator,
          getFieldsError = _this$props$form.getFieldsError;
      return _react["default"].createElement(_antd.Form, {
        onSubmit: this.handleSubmit,
        className: 'login-form'
      }, error && error.message !== 'auth/inactivityLogout/text' && _react["default"].createElement("p", {
        className: "text-danger text-center"
      }, translate(error.message)), _react["default"].createElement(_Loader["default"], {
        spinning: isLoading
      }, _react["default"].createElement(FormItem, {
        className: "mt-4"
      }, getFieldDecorator('username', {
        rules: [{
          required: true,
          message: translate('login/username/error')
        }]
      })(_react["default"].createElement(_antd.Input, {
        prefix: _react["default"].createElement(_antd.Icon, {
          type: "user",
          style: {
            fontSize: 13
          }
        }),
        placeholder: translate('login/username')
      }))), _react["default"].createElement(FormItem, null, getFieldDecorator('password', {
        rules: [{
          required: true,
          message: translate('login/password/error')
        }]
      })(_react["default"].createElement(_antd.Input, {
        prefix: _react["default"].createElement(_antd.Icon, {
          type: "lock",
          style: {
            fontSize: 13
          }
        }),
        type: "password",
        placeholder: translate('login/password')
      }))), _react["default"].createElement(_antd.Row, {
        type: "flex",
        justify: "space-between",
        align: "middle"
      }, _react["default"].createElement(_antd.Button, {
        style: {
          margin: '0 auto'
        },
        type: "primary",
        htmlType: "submit",
        disabled: this.hasErrors(getFieldsError())
      }, translate('login/login')))));
    }
  }]);

  return LoginForm;
}(_react["default"].Component);

exports.LoginForm = LoginForm;

_defineProperty(LoginForm, "propTypes", {
  error: PropTypes.object,
  isLoading: PropTypes.bool,
  auth: PropTypes.func
});